import { gql } from "@apollo/client";

export const GET_STATS_BY_STATUS_HSC= gql`
query StatsByStatusHSC {
  statsByStatusHSC {
    success
    message
    data
    error
  }
}
`

export const GET_STATS_BY_TYPE = gql`
query StatsByType {
  statsByType {
    success
    message
    data
    error
  }
}
`

export const CLOSING_STATS = gql`
query closingStats {
  closingStats {
    success
    message
    data {
      CLOSE_OF_ESCROW
      CLOSED_PROPERTIES
      CLOSED_PRICE
    }
    error
  }
}
`

export const GET_STATS_BY_BUYER_STATE = gql`
query GetStatsByBuyerState($date: String!) {
  getStatsByBuyerState(date: $date) {
    company_state
    total_properties
  }
}
`


export const GET_PRIME_RATES = gql`
query GetPrimeRatesList($pageOptions: PageOptions) {
  getPrimeRatesList(pageOptions: $pageOptions) {
    arcimedes_row_id
    prime_rate
    this_week
    month_ago
    year_ago
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`

export const GET_STATS_BY_STATUS = gql`
query statsByStatus($since: String!) {
  statsByStatus(SINCE: $since)
}
`

export const GET_NEW_HSC_RATES = gql`
query GetNewHscRates {
  getNewHscRates{
    arcimedes_row_id
    us_treasury_1yr
    us_treasury_3yr
    us_treasury_5yr
    us_treasury_7yr
    us_treasury_10yr
    sofr_swap_1yr
    sofr_swap_3yr
    sofr_swap_5yr
    sofr_rate
    prime_rate
    fed_funds_rate
    current_us_treasury_1yr
    current_us_treasury_3yr
    current_us_treasury_5yr
    current_us_treasury_7yr
    current_us_treasury_10yr
    current_sofr_swap_1yr
    current_sofr_swap_3yr
    current_sofr_swap_5yr
    current_sofr_rate
    current_prime_rate
    current_fed_funds_rate

  }
}
`